import React, { FC } from 'react'
//@ts-expect-error-next-line
import unclaimedIcon from '../../../images/Icon_Unclaimed.svg'
//@ts-expect-error-next-line
import claimedIcon from '../../../images/Icon_Claimed.svg'
//@ts-expect-error-next-line
import verifiedIcon from '../../../images/Icon_Verified.svg'
import Tooltip from '../../molecules/Tooltip'
import centerIsClaimed from '../../../domain/center/useCases/centerIsClaimed'
import centerIsClaimedAndVerified from '../../../domain/center/useCases/centerIsClaimedAndVerified'
import { Center } from '@/types/models'

type CenterStatusBadgeProps = {
  center: Center
}
type TooltipProps = {
  triggerText: string
  tooltipTitle: string
  triggerImage: string
  unclaimedCenter?: boolean
  tooltipBodyText: string
  footerLinkText: string
  footerLink: string
}

const CenterStatusBadge: FC<CenterStatusBadgeProps> = ({ center }) => {
  let props: TooltipProps = {
    triggerText: 'Unclaimed',
    tooltipTitle: 'Unclaimed',
    triggerImage: unclaimedIcon,
    unclaimedCenter: true,
    tooltipBodyText:
      'This provider hasn’t verified their profile’s information. Are you the owner of this center? Claim your listing to better manage your presence on Recovery.com. ',
    footerLink: 'https://providers.recovery.com',
    footerLinkText: 'Learn More'
  }

  if (centerIsClaimed(center)) {
    props = {
      triggerText: 'Claimed',
      tooltipTitle: 'Claimed',
      triggerImage: claimedIcon,
      tooltipBodyText:
        'Recovery.com has connected directly with this treatment provider to validate the information in their profile.',
      footerLink: 'https://providers.recovery.com',
      footerLinkText: 'Learn More'
    }
  }

  if (centerIsClaimedAndVerified(center)) {
    props = {
      triggerText: 'Verified',
      tooltipTitle: 'Verified',
      triggerImage: verifiedIcon,
      tooltipBodyText: `This provider’s information has been quality-checked by Recovery.com’s Research Team for accuracy and completeness, including center verification through appropriate third-party organizations.<br /><a href="#certificates" style='text-decoration:none'>View This Center’s Verified License</a>`,
      footerLinkText: 'Learn More',
      footerLink: '/claim-verify-process/'
    }
  }

  return (
    <span className="relative z-20 inline-block">
      <Tooltip {...props} />
    </span>
  )
}

export default CenterStatusBadge
